
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g0xygkL3gowfrEohABG3XnOoY90Y4Ph6eI422kiS_45LQIMeta } from "/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexk63c6xFFqvVZn3pya_45C3rCdnbzZWZU5mQ_45ddbu7bZjQMeta } from "/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchgrxyCgGuK7BAKoWFx_g1RU1RlEFLDi7tOCtjhMmsdJkMeta } from "/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index20RKsOCL3XZVAchZ0xXdztkNfuNlPD0Vn0q5g9Y_45Z7gMeta } from "/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_933GIbieJw4sSMZfgUFbrdWj5SisqYyaNCy9pxwrWPSPMMeta } from "/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexQcFVOmqFjDJLZHJazL__r2ILpzW_HXwr24StCCjVYn4Meta } from "/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Ls7EDqR1V69GzkibQoAAABrfUXdc5PyNiezreyJBGFoMeta } from "/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index3jPmJw9axQp8BKLE5_457UvlgL6toRSz_P5c4As60aKZ4Meta } from "/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93WkGQQfGmTX8xqXzYHkmjTeCWrZ8uGyn_453h2Znsmx_yYMeta } from "/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexf_WUOPrRCNPpEvUfe6l_45a4UebkeIAb_uUPjG_45_IzUe8Meta } from "/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexoJXx7RIaBiVEJNMAWqCsmCqKzvUuNfdoldER6LPmK4gMeta } from "/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexQcFVOmqFjDJLZHJazL__r2ILpzW_HXwr24StCCjVYn4Meta || {},
    component: () => import("/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index3jPmJw9axQp8BKLE5_457UvlgL6toRSz_P5c4As60aKZ4Meta || {},
    component: () => import("/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexf_WUOPrRCNPpEvUfe6l_45a4UebkeIAb_uUPjG_45_IzUe8Meta || {},
    component: () => import("/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexoJXx7RIaBiVEJNMAWqCsmCqKzvUuNfdoldER6LPmK4gMeta || {},
    component: () => import("/codebuild/output/src840878277/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]